module.exports = "https://cdn.hellotech.com/client-assets/phones_and_tablets_mobile_01d03a3b66933d0ae1a4266fc2a90184.webp";